import { AddQueryParamsToUrl } from './models';
import { PurchaseInfo } from '~/models/Purchase';
import Storage from '@sunbit-dev/common/services/storage';
import { itemType } from '@sunbit-dev/common/services/storage/Storage';
import { ApplicationLocalStorageKey } from '~/enums/ApplicationLocalStorageKey';

const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

export const isValidUrl = (url?: string): boolean => {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return ALLOWED_PROTOCOLS.has(parsed.protocol);
  } catch {
    return false;
  }
};

export const getUrlHostname = (url?: string): string | undefined => {
  if (!url || !isValidUrl(url)) return undefined;
  return new URL(url).hostname;
};

export const addQueryParamsToUrl = ({ url: _url, params }: AddQueryParamsToUrl): string => {
  const url = new URL(_url);
  Object.entries(params || {}).forEach(([key, value]) => url.searchParams.append(key, value.toString()));
  return url.href;
};

export const convertTZ = (date: string | Date, tzString: string): Date => {
  return new Date((typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', { timeZone: tzString }));
};

export const getApplicationLocalStorageValue = (key: ApplicationLocalStorageKey): itemType => Storage.getItem(key);

export const setApplicationLocalStorage = (purchaseInfo?: Partial<PurchaseInfo>): void => {
  Storage.setItem(ApplicationLocalStorageKey.MERCHANT_VERTICAL, purchaseInfo?.merchantVertical);
  Storage.setItem(ApplicationLocalStorageKey.LOAN_APPLICATION_ORIGIN, purchaseInfo?.loanApplicationOrigin);
};

export const clearRefererFromLocalStorage = (): void => {
  Storage.clearItem(ApplicationLocalStorageKey.REFERER);
};

export const formatDisplayFirstName = (name: string): string => {
  return name.length > 1 ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : name;
};
